export default __webpack_public_path__ + "static/Pacakages-7cd5cd81750c72191249b1e457ce706d.svg";